module.exports = __webpack_public_path__ + "img/4b1f44e971c2eb9a.png";